var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 30,
    viewBox: "0 0 101 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.70862,
    width: 18,
    height: 24,
    rx: 2,
    transform: "rotate(-19.574 0.5 6.70862)",
    fill: "url(#paint0_linear_1130_934)",
    stroke: "url(#paint1_linear_1130_934)",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 0.678223,
    width: 18,
    height: 24,
    rx: 2,
    fill: "url(#paint2_linear_1130_934)",
    stroke: "url(#paint3_linear_1130_934)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7665 12.1507L15.485 6L13.5 7.03437L15.7752 12.6663C15.834 12.8116 15.834 12.972 15.7752 13.1169L13.5 18.7488L15.485 19.7832L18.7665 13.6324L22.048 19.7832L24.0329 18.7488L21.7578 13.1169C21.699 12.9715 21.699 12.8111 21.7578 12.6663L24.0329 7.03437L22.048 6L18.7665 12.1507Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.356 24.228C39.092 24.228 37.916 23.996 36.828 23.532C35.756 23.068 34.82 22.428 34.02 21.612C33.236 20.78 32.62 19.804 32.172 18.684C31.724 17.564 31.5 16.332 31.5 14.988C31.5 13.66 31.716 12.436 32.148 11.316C32.596 10.18 33.22 9.20397 34.02 8.38797C34.82 7.55597 35.756 6.91597 36.828 6.46797C37.9 6.00397 39.076 5.77197 40.356 5.77197C41.62 5.77197 42.748 5.98797 43.74 6.41997C44.748 6.85197 45.596 7.41997 46.284 8.12397C46.972 8.81197 47.468 9.56397 47.772 10.38L45.228 11.58C44.844 10.62 44.228 9.84397 43.38 9.25197C42.548 8.64397 41.54 8.33997 40.356 8.33997C39.172 8.33997 38.124 8.61997 37.212 9.17997C36.3 9.73997 35.588 10.516 35.076 11.508C34.58 12.5 34.332 13.66 34.332 14.988C34.332 16.316 34.58 17.484 35.076 18.492C35.588 19.484 36.3 20.26 37.212 20.82C38.124 21.364 39.172 21.636 40.356 21.636C41.54 21.636 42.548 21.34 43.38 20.748C44.228 20.156 44.844 19.38 45.228 18.42L47.772 19.62C47.468 20.42 46.972 21.172 46.284 21.876C45.596 22.58 44.748 23.148 43.74 23.58C42.748 24.012 41.62 24.228 40.356 24.228Z",
    fill: "url(#paint4_linear_1130_934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5539 24.228C53.6739 24.228 52.8979 24.076 52.2259 23.772C51.5699 23.452 51.0579 23.02 50.6899 22.476C50.3219 21.916 50.1379 21.26 50.1379 20.508C50.1379 19.804 50.2899 19.172 50.5939 18.612C50.9139 18.052 51.4019 17.58 52.0579 17.196C52.7139 16.812 53.5379 16.54 54.5299 16.38L59.0419 15.636V17.772L55.0579 18.468C54.3379 18.596 53.8099 18.828 53.4739 19.164C53.1379 19.484 52.9699 19.9 52.9699 20.412C52.9699 20.908 53.1539 21.316 53.5219 21.636C53.9059 21.94 54.3939 22.092 54.9859 22.092C55.7219 22.092 56.3619 21.932 56.9059 21.612C57.4659 21.292 57.8979 20.868 58.2019 20.34C58.5059 19.796 58.6579 19.196 58.6579 18.54V15.204C58.6579 14.564 58.4179 14.044 57.9379 13.644C57.4739 13.228 56.8499 13.02 56.0659 13.02C55.3459 13.02 54.7139 13.212 54.1699 13.596C53.6419 13.964 53.2499 14.444 52.9939 15.036L50.7379 13.908C50.9779 13.268 51.3699 12.708 51.9139 12.228C52.4579 11.732 53.0899 11.348 53.8099 11.076C54.5459 10.804 55.3219 10.668 56.1379 10.668C57.1619 10.668 58.0659 10.86 58.8499 11.244C59.6499 11.628 60.2659 12.164 60.6979 12.852C61.1459 13.524 61.3699 14.308 61.3699 15.204V23.94H58.7779V21.588L59.3299 21.66C59.0259 22.188 58.6339 22.644 58.1539 23.028C57.6899 23.412 57.1539 23.708 56.5459 23.916C55.9539 24.124 55.2899 24.228 54.5539 24.228Z",
    fill: "url(#paint5_linear_1130_934)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0209 23.94V10.956H67.6129V13.572L67.3729 13.188C67.6609 12.34 68.1249 11.732 68.7649 11.364C69.4049 10.98 70.1729 10.788 71.0689 10.788H71.8609V13.26H70.7329C69.8369 13.26 69.1089 13.54 68.5489 14.1C68.0049 14.644 67.7329 15.428 67.7329 16.452V23.94H65.0209Z",
    fill: "url(#paint6_linear_1130_934)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1962 24.228C78.9482 24.228 77.8282 23.932 76.8362 23.34C75.8602 22.732 75.0842 21.916 74.5082 20.892C73.9482 19.868 73.6682 18.716 73.6682 17.436C73.6682 16.156 73.9562 15.004 74.5322 13.98C75.1082 12.956 75.8842 12.148 76.8602 11.556C77.8362 10.964 78.9402 10.668 80.1722 10.668C81.2122 10.668 82.1322 10.876 82.9322 11.292C83.7322 11.708 84.3642 12.284 84.8282 13.02L84.4202 13.644V5.77197H87.1082V23.94H84.5402V21.3L84.8522 21.804C84.4042 22.588 83.7642 23.188 82.9322 23.604C82.1002 24.02 81.1882 24.228 80.1962 24.228ZM80.4602 21.708C81.2122 21.708 81.8842 21.524 82.4762 21.156C83.0842 20.788 83.5562 20.284 83.8922 19.644C84.2442 18.988 84.4202 18.252 84.4202 17.436C84.4202 16.62 84.2442 15.892 83.8922 15.252C83.5562 14.612 83.0842 14.108 82.4762 13.74C81.8842 13.372 81.2122 13.188 80.4602 13.188C79.7082 13.188 79.0282 13.372 78.4202 13.74C77.8122 14.108 77.3402 14.612 77.0042 15.252C76.6682 15.892 76.5002 16.62 76.5002 17.436C76.5002 18.252 76.6682 18.988 77.0042 19.644C77.3402 20.284 77.8042 20.788 78.3962 21.156C79.0042 21.524 79.6922 21.708 80.4602 21.708Z",
    fill: "url(#paint7_linear_1130_934)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5543 24.228C94.2263 24.228 93.0583 23.9 92.0503 23.244C91.0583 22.588 90.3623 21.708 89.9623 20.604L92.0503 19.62C92.4023 20.356 92.8823 20.94 93.4903 21.372C94.1143 21.804 94.8023 22.02 95.5543 22.02C96.1943 22.02 96.7143 21.876 97.1143 21.588C97.5143 21.3 97.7143 20.908 97.7143 20.412C97.7143 20.092 97.6263 19.836 97.4503 19.644C97.2743 19.436 97.0503 19.268 96.7783 19.14C96.5223 19.012 96.2583 18.916 95.9863 18.852L93.9463 18.276C92.8263 17.956 91.9863 17.476 91.4263 16.836C90.8823 16.18 90.6103 15.42 90.6103 14.556C90.6103 13.772 90.8103 13.092 91.2103 12.516C91.6103 11.924 92.1623 11.468 92.8663 11.148C93.5703 10.828 94.3623 10.668 95.2423 10.668C96.4263 10.668 97.4823 10.964 98.4103 11.556C99.3383 12.132 99.9943 12.94 100.378 13.98L98.2903 14.964C98.0343 14.34 97.6263 13.844 97.0663 13.476C96.5223 13.108 95.9063 12.924 95.2183 12.924C94.6263 12.924 94.1543 13.068 93.8023 13.356C93.4503 13.628 93.2743 13.988 93.2743 14.436C93.2743 14.74 93.3543 14.996 93.5143 15.204C93.6743 15.396 93.8823 15.556 94.1383 15.684C94.3943 15.796 94.6583 15.892 94.9303 15.972L97.0423 16.596C98.1143 16.9 98.9383 17.38 99.5143 18.036C100.09 18.676 100.378 19.444 100.378 20.34C100.378 21.108 100.17 21.788 99.7543 22.38C99.3543 22.956 98.7943 23.412 98.0743 23.748C97.3543 24.068 96.5143 24.228 95.5543 24.228Z",
    fill: "url(#paint8_linear_1130_934)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1130_934",
    x1: 0.52521,
    y1: 6.70862,
    x2: 23.7927,
    y2: 14.0783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1130_934",
    x1: 6.05705,
    y1: 12.6286,
    x2: 14.6078,
    y2: 15.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1130_934",
    x1: 9.52521,
    y1: 0.678223,
    x2: 32.7927,
    y2: 8.04792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1130_934",
    x1: 15.057,
    y1: 6.59822,
    x2: 23.6078,
    y2: 8.99777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1130_934",
    x1: 52.7644,
    y1: 10.3245,
    x2: 64.7298,
    y2: 27.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1130_934",
    x1: 52.7644,
    y1: 10.3245,
    x2: 64.7298,
    y2: 27.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1130_934",
    x1: 52.7644,
    y1: 10.3245,
    x2: 64.7298,
    y2: 27.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1130_934",
    x1: 52.7644,
    y1: 10.3245,
    x2: 64.7298,
    y2: 27.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1130_934",
    x1: 52.7644,
    y1: 10.3245,
    x2: 64.7298,
    y2: 27.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.730e941ce503d4de14d79332c50505d0.svg";
export { ForwardRef as ReactComponent };